import { render, staticRenderFns } from "./MyFavItemMobile.vue?vue&type=template&id=6b74b59d&scoped=true"
import script from "./MyFavItemMobile.vue?vue&type=script&lang=js"
export * from "./MyFavItemMobile.vue?vue&type=script&lang=js"
import style0 from "./MyFavItemMobile.vue?vue&type=style&index=0&id=6b74b59d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b74b59d",
  null
  
)

export default component.exports